<script>
export default {
    props: {
        ratePlan: String,
    },
}
</script>

<template>
    <div>
        <div class="tw:inline-block tw:text-xs tw:lg:text-sm tw:rounded-full tw:border tw:border-solid tw:border-zinc-300 tw:bg-e6">
            <div class="tw:flex tw:items-stretch tw:font-medium">
                <div class="tw:py-2 tw:font-semibold tw:text-zinc-700 tw:pl-4 tw:mr-4 tw:flex tw:items-center">Book with</div>
                <button
                    class="tw:py-2 tw:border-0 tw:rounded-l-full tw:pl-6 tw:pr-4 tw:flex tw:items-center tw:cursor-pointer"
                    v-on:click="$emit('selectRatePlan', { detail: { ratePlan: 'usd' }})"
                    v-bind:class="{
                        'tw:bg-vacatia-plus tw:text-white tw:hover:bg-[#2146b3] tw:hover:text-f2': ratePlan === 'usd',
                        'tw:bg-white tw:text-vacatia-plus tw:hover:bg-f2 tw:hover:text-[#2146b3]': ratePlan === 'points',
                    }"
                >
                    Dollars&nbsp;(USD)
                </button>
                <button
                    class="tw:py-2 tw:border-0 tw:rounded-r-full tw:pr-6 tw:pl-4 tw:cursor-pointer"
                    v-on:click="$emit('selectRatePlan', { detail: { ratePlan: 'points' }})"
                    v-bind:class="{
                        'tw:bg-vacatia-plus tw:text-white tw:hover:bg-[#2146b3] tw:hover:text-f2': ratePlan === 'points',
                        'tw:bg-white tw:text-vacatia-plus tw:hover:bg-f2 tw:hover:text-[#2146b3]': ratePlan === 'usd',
                    }"
                >
                    Vacatia Points
                    <small class="tw:block tw:text-xs">(highest&nbsp;savings)</small>
                </button>
            </div>
        </div>
    </div>
</template>
